import { HttpMethod } from '../types.js';
import { Minute } from '@nu-art/ts-common';
export const ApiDef_ActionProcessing = {
    vv1: {
        execute: { method: HttpMethod.POST, path: 'v1/action-processor/execute', timeout: 5 * Minute },
        list: { method: HttpMethod.GET, path: 'v1/action-processor/list' },
    }
};
//# sourceMappingURL=apis.js.map